import { useSuspenseQuery } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { listBillingEmailEnabledProducts } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'

/**
 * プロダクト個別送付先を設定可能なプロダクト (productId -> プロダクト名) を取得する。
 * 組織が有効なベースプランを契約しており、かつ請求書送付先設定が有効なプロダクトのみ含まれる。
 */
export function useBillingEmailEnabledProducts(): Map<number, string> {
  const { t } = useTranslation()

  const res = useSuspenseQuery(
    listBillingEmailEnabledProducts,
    {},
    {
      select: (data) =>
        new Map<number, string>(
          Object.entries(data.billingEnabledProducts).map(([id, name]) => [
            Number(id),
            name,
          ]),
        ),
    },
  )
  if (res.isError || res.data === undefined) {
    throw new Error(t('message.fetchFail', { entity: t('domain.billing') }))
  }
  return res.data
}
